import React, { useState } from 'react';
import { TabPanel } from '../../../../../components/tabs';
import { IDetailsTabPanel } from './interfaces';
import { Paper, Table, TableBody, TableContainer } from '@mui/material';
import {
  ValueAgentRow,
  ValueContactListRow,
  ValueDateRow,
  ValueRow,
  ValueTextRow,
} from '../../../../../components/table';
import { getActivityDateType } from '../../helpers';
import { useTranslation } from 'react-i18next';
import { FloatingActionsButtons } from '../../../../../components/FloatingActionsButtons';
import { DeleteAction } from '../../../../../components/FloatingActionsButtons/components/DeleteAction';
import { EditAction } from '../../../../../components/FloatingActionsButtons/components/EditAction';
import { ResolveAction } from '../../components/ResolveAction';
import { UpsertPlannedActivityDialog } from '../../../dialogs/UpsertPlannedActivityDialog';
import { DeletePlannedActivityDialog } from '../../../dialogs/DeletePlannedActivityDialog';
import { ResolvePlannedActivityDialog } from '../../../dialogs/ResolvePlannedActivityDialog';

export const DetailsTabPanel: React.FC<IDetailsTabPanel> = ({
  index,
  value,
  plannedActivity,
}): JSX.Element => {
  const { t } = useTranslation();
  const dateType = getActivityDateType(plannedActivity);

  const [showEditDialog, setShowEditDialog] = useState<boolean>(false);
  const [showResolveActivityDialog, setShowResolveActivityDialog] =
    useState<boolean>(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

  return (
    <TabPanel value={value} index={index}>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <ValueDateRow
              label={t('entities:plannedActivity.performAt')}
              date={plannedActivity.performAt}
              withTime={false}
            />

            {dateType === 'exact' && plannedActivity.startTime && (
              <ValueRow
                label={t('entities:common.time')}
                value={plannedActivity.startTime}
              />
            )}

            {dateType === 'range' && (
              <ValueRow
                label={t('entities:plannedActivity.timeRange')}
                value={`${plannedActivity.startTime} - ${plannedActivity.endTime}`}
              />
            )}

            <ValueRow
              label={t('entities:activityLog.action')}
              value={plannedActivity.action.name}
            />
            <ValueContactListRow
              label={t('entities:activityLog.contacts')}
              contacts={plannedActivity.contacts}
            />
            <ValueRow
              label={t('entities:activityLog.client')}
              value={plannedActivity.client.name}
            />
            <ValueRow
              label={t('entities:activityLog.group')}
              value={plannedActivity.client.group?.name}
            />
            <ValueAgentRow
              label={t('entities:activityLog.agent')}
              agent={plannedActivity.agent}
            />
            <ValueTextRow
              label={t('entities:plannedActivity.description')}
              value={plannedActivity.description}
            />
            {plannedActivity.remainingWork && (
              <ValueTextRow
                label={t('entities:plannedActivity.remainingWork')}
                value={plannedActivity.remainingWork}
              />
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <FloatingActionsButtons>
        <DeleteAction
          onClick={() => {
            setShowDeleteDialog(true);
          }}
        />
        <EditAction
          onClick={() => {
            setShowEditDialog(true);
          }}
        />
        <ResolveAction onClick={() => setShowResolveActivityDialog(true)} />
      </FloatingActionsButtons>

      <UpsertPlannedActivityDialog
        plannedActivity={plannedActivity}
        show={showEditDialog}
        onClose={() => setShowEditDialog(false)}
      />
      <DeletePlannedActivityDialog
        show={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        plannedActivityId={plannedActivity.id}
      />
      <ResolvePlannedActivityDialog
        plannedActivityId={plannedActivity.id}
        title={plannedActivity.title}
        show={showResolveActivityDialog}
        onClose={() => setShowResolveActivityDialog(false)}
      />
    </TabPanel>
  );
};
